import React, { useState, useEffect, useRef } from "react";
import "../../App.css";

import {BackToIndustryVerticalsButton} from "../layout/BackButton";
import QuickLinksSection from "../products/QuickLinksSection";

// Information Technology Detail Page
function InformationTechnologyPage({ handleNavClick }) {
  return (
    <div className="industry-detail-page it-page">
      <BackToIndustryVerticalsButton handleNavClick={handleNavClick} />

      {/* IT Header */}
      <div className="it-detail-header">
        <div className="section__container">
          <h2 className="section__title">Information Technology</h2>
          <p className="section__intro">
            Transforming IT infrastructure and operations through advanced geospatial solutions.
          </p>
        </div>
      </div>

      {/* About IT Section */}
      <section className="it-about-section">
        <div className="section__container it-about-container">
          <div className="it-about-text">
            <h2>About IT</h2>
            <p>
              Information Technology (IT) refers to the use of computers, software, networks, and other digital systems to manage, process, store, secure, and transmit information. It plays a vital role in modern society by enabling communication, automating processes, supporting decision-making, and driving innovation across industries.
            </p>
          </div>
          <div className="it-about-image">
            <img src="/it_base.png" alt="IT Infrastructure" />
          </div>
        </div>
      </section>

      {/* IT Feature Sections - Alternating Layout */}

      {/* Section 1: Hardware (Image Left, Text Right) */}
      <ITFeatureSection
        title="Hardware"
        text="We offer a customized automation solution specifically designed for the manufacturing industry, which includes areas such as design, planning, production, marketing, quality control, purchasing, inventory management, finance, maintenance, and more."
        imgSrc="/it.jpg"
        imgAlt="IT Hardware"
      />

      {/* Section 2: Software (Text Left, Image Right) */}
      <ITFeatureSection
        text="In addition to our robust automation services, we also offer comprehensive Mobile & PC Security Solutions tailored to safeguard your digital infrastructure. Our cutting-edge security measures protect against a wide range of threats, ensuring that both mobile devices and personal computers operate safely and efficiently."
        imgSrc="/it1.jpg"
        imgAlt="IT Software"
        reverse
      />

      {/* Section 3: Networking (Image Left, Text Right) */}
      <ITFeatureSection
        title="Networking & Communication"
        text="Internet, intranets, LAN/WAN, and wireless technologies that connect devices, enable data sharing, and facilitate communication across local and global networks."
        imgSrc="/it-networking.png"
        imgAlt="IT Networking"
      />

      {/* Section 4: Data Management (Text Left, Image Right) */}
      <ITFeatureSection
        title="Data Management"
        text="Collection, storage, retrieval, and analysis of data using advanced database systems, data warehouses, and analytics platforms to support informed decision-making."
        imgSrc="/it-data.png"
        imgAlt="IT Data Management"
        reverse
      />

      {/* Section 5: Cybersecurity (Image Left, Text Right) */}
      <ITFeatureSection
        title="Cybersecurity"
        text="Protecting systems and data from unauthorized access, attacks, and breaches through comprehensive security measures, monitoring systems, and threat detection protocols."
        imgSrc="/it-security.png"
        imgAlt="IT Cybersecurity"
      />

      {/* Section 6: Cloud Computing (Text Left, Image Right) */}
      <ITFeatureSection
        title="Cloud Computing & Virtualization"
        text="Hosting services, applications, and infrastructure over the internet, enabling scalable, flexible, and cost-effective IT solutions for businesses of all sizes."
        imgSrc="/it-cloud.png"
        imgAlt="IT Cloud Computing"
        reverse
      />

      {/* Quick Links Section */}
      <QuickLinksSection
        handleNavClick={handleNavClick}
        links={[
          { id: 'gis-services', title: 'GIS and Data Services',icon:'/bgs/GIS.png' },
          { id: 'environment', title: 'Environment',icon:'/bgs/env.png' },
          { id: 'health', title: 'Health',icon:'/bgs/health.png' },
          { id: 'agriculture', title: 'Agriculture',icon: '/bgs/agriculture.png' },
          { id: 'education-research', title: 'Education & Research',icon:'/bgs/edu.png' }
        ]}
      />
    </div>
  );
}


// Reusable IT Feature Section Component
function ITFeatureSection({ title, text, imgSrc, imgAlt, reverse }) {
  return (
    <section className={`it-feature-section${reverse ? ' reverse' : ''}`}>
      <div className="section__container it-feature-container">
        <div className="it-feature-image">
          <img src={imgSrc} alt={imgAlt} />
        </div>
        <div className="it-feature-text">
          <h3>{title}</h3>
          <p>{text}</p>
        </div>
      </div>
    </section>
  );
}

export default InformationTechnologyPage;
export { ITFeatureSection };